export const environment = {
  production: false,
  existingCaseWorthyAPIURL:
    "https://qa.cw.caseworthy.net/CaseWorthy_QA.API/",
    nextGenAccountsAPIURL: "https://qa.api.cwe.cw.caseworthy.net/account/services/v1/",
    nextGenFormsAPIURL: "https://qa.api.cwe.cw.caseworthy.net/forms/services/v1/",
    nextGenQueryAPIURL: "https://qa.api.cwe.cw.caseworthy.net/query-apbuilder/services/v1/",
    nextGenServerUrl: "https://qa.api.cwe.cw.caseworthy.net/",
};
